module.exports = __webpack_public_path__ + "static/media/logo.ec2b2e80.png";